import { PrismicImage } from "@prismicio/react";

const GoogleReview = ({ note, picto, className, sm }) => {
  return <div className={className}>
    <div
      className="bg-white border-2 border-dark-grey rounded-full circle-shape w-[95px] h-[95px] md:w-[115px] md:h-[115px] flex flex-col items-center justify-center">
      <p className="text-google text-center">
        {note}
      </p>
      <PrismicImage field={picto} className="w-[65px] h-[9px] object-contain"  loading="lazy"/>
      <p className="text-google text-center"> sur Google</p>
    </div>
  </div>
};

export default GoogleReview;